// extracted by mini-css-extract-plugin
export default {"editorWrapper":"react-quill_editorWrapper__Hjqmr","preview":"react-quill_preview__ZOxOC","quillSpinner":"react-quill_quillSpinner__0APrh"};